import {IApiModel} from './api-model.interface';
import moment from 'moment';
import {Account} from './account.model';
import {User} from './user.model';

export enum BankConnectionType {
    FinApi = 'FinApi',
    BanksApi = 'BanksApi',
    Konfipay = 'konfipay',
    GoCardless = 'GoCardless'
}

export enum BanksApiType {
    BanksApi = 'BanksApi',
    Ebics = 'Ebics'
}

export class BankConnectedProfileModel implements IApiModel<BankConnectedProfileModel> {
    id: number;
    bankId: number;
    bankConnectionId: number;
    bankName: string;
    bic: string;
    dateCreated: string;
    createdBy: string;
    accounts: Account[];
    aisConsent: any = null;
    minBookingDate: string;
    connectionType: BankConnectionType = null;
    banksApiType: BanksApiType = null;
    issues: string;
    supportsAccountReselection: boolean;

    getApiModel(): any {
        return undefined;
    }

    setFromApiModel(apiModel: any): this {
        this.id = apiModel.id;
        this.bankId = apiModel?.bank?.id;
        this.bankConnectionId = apiModel.id;

        if (apiModel.accounts && apiModel.accounts.length) {
            this.accounts = apiModel.accounts.map(item => new Account().setFromApiModel(item));
            if (apiModel.accountIds && this.accounts.length === apiModel.accountIds.length) {
                this.accounts.forEach((item, index) => {
                        item.accountId = apiModel.accountIds[index];
                    }
                );
            }
        }

        switch (apiModel.open_banking_user?.provider) {
            case BankConnectionType.BanksApi.toUpperCase():
                this.connectionType = BankConnectionType.BanksApi;
                break;
            case BankConnectionType.FinApi.toUpperCase():
                this.connectionType = BankConnectionType.FinApi;
                break;
            case BankConnectionType.Konfipay.toUpperCase():
                this.connectionType = BankConnectionType.Konfipay;
                break;
            case BankConnectionType.GoCardless.toUpperCase():
                this.connectionType = BankConnectionType.GoCardless;
                break;
        }
        this.banksApiType = apiModel.type === BanksApiType.Ebics.toUpperCase() ? BanksApiType.Ebics :
            this.connectionType === BankConnectionType.BanksApi ? BanksApiType.BanksApi : null;

        this.bankName = apiModel.bank_name || (this.banksApiType === BanksApiType.Ebics ? 'Setup.Bank.BANKSapiEBICS.BankName' : null);
        this.bic = apiModel.bank_bic;
        this.dateCreated = apiModel.date_created;
        if (apiModel.author) {
            let author = new User().setFromApiModel(apiModel.author);
            this.createdBy = author.fullName;
        }
        if (apiModel.consent_expiry_date) {
            let expireDate = apiModel.consent_expiry_date ? moment(apiModel.consent_expiry_date) : null;
            this.aisConsent = {
                expireDate: expireDate,
                expired: expireDate && moment().isAfter(expireDate)
            };
        }
        this.minBookingDate = apiModel.min_booking_date;
        this.issues = (apiModel.issues || []).join('; ');
        this.supportsAccountReselection = !!apiModel.supports_account_reselection;
        return this;
    }
}
